import React, { useEffect } from "react";
import { Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

export function getRouteSections(sections) {
  const features = [];
  const bounds = L.latLngBounds([]);
  sections.forEach(section => {
    try {
      const data = typeof section.geojson === "string" ? JSON.parse(section.geojson) : section.geojson;
      if (!data) return;
      const sectionBounds = L.geoJSON(data).getBounds();
      if (!sectionBounds.isValid()) return;
      features.push({ ...section, data });
      bounds.extend(sectionBounds);
    } catch {
      // An unavailable section must never redirect the view to remote pins.
    }
  });
  return { features, bounds: bounds.isValid() ? bounds : null };
}

const defaultIcon = new L.Icon.Default({
  iconSize: [18, 30], iconAnchor: [9, 30], popupAnchor: [0, -25], shadowSize: [30, 30],
});

export default function RouteMapMarkers({ points, bounds }) {
  const map = useMap();
  useEffect(() => {
    // Measure the viewport after the fullscreen dialog finishes opening.
    const timer = setTimeout(() => {
      map.invalidateSize();
      if (bounds) map.fitBounds(bounds, { padding: [32, 32], maxZoom: 18, animate: false });
    }, 250);
    return () => clearTimeout(timer);
  }, [map, bounds]);

  return points.filter(point =>
    point.position.every(value => value != null && value !== "" && Number.isFinite(Number(value))) &&
    Math.abs(Number(point.position[0])) <= 90 && Math.abs(Number(point.position[1])) <= 180
  ).map(point => (
    <Marker key={point.id} position={point.position} icon={point.icon || defaultIcon}>
      <Popup>{point.popup}</Popup>
    </Marker>
  ));
}
